import React from "react";
import {
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    ListItemSecondaryAction,
    Box,
    Chip,
    Tooltip,
    IconButton,
    ButtonGroup,
} from "@mui/material";

// Components
import Icon from "@/theme/vectors/bundle";

// Utils
import { getMediaTypeIcon, formatFileSize } from "@/utils/products/mediaHelpers";

const MediaList = ({ medias, onOpenDeleteModal, t }) => {
    return (
        <List>
            {medias.map((media) => (
                <ListItem
                    key={media.id}
                    sx={{ 
                        py: 1.5,
                        position: 'relative',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        }
                    }}
                    secondaryAction={
                        <ButtonGroup size="small">
                            <Tooltip title="Preview">
                                <IconButton
                                    component="a"
                                    href={media.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    size="small"
                                >
                                    <Icon name="view" size={18} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete">
                                <IconButton
                                    onClick={() => onOpenDeleteModal(media.id)}
                                    color="error"
                                    size="small"
                                >
                                    <Icon name="remove" size={18} />
                                </IconButton>
                            </Tooltip>
                        </ButtonGroup>
                    }
                >
                    <ListItemIcon sx={{ mr: 2, minWidth: 60 }}>
                        <Box 
                            sx={{ 
                                width: 50, 
                                height: 50, 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                border: '1px dashed',
                                borderColor: 'divider',
                                borderRadius: 1
                            }}
                        >
                            {getMediaTypeIcon(media.type)}
                        </Box>
                    </ListItemIcon>
                    <ListItemText 
                        primary={media.filename}
                        secondary={
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mt: 0.5 }}>
                                <Chip 
                                    size="small" 
                                    label={media.type} 
                                />
                                {media.filesize && (
                                    <Chip 
                                        size="small" 
                                        label={formatFileSize(media.filesize)} 
                                    />
                                )}
                            </Box>
                        }
                    />
                </ListItem>
            ))}
        </List>
    );
};

export default MediaList;